














































































import { Building as BuildingEnum, Condition as ConditionEnum } from "@gaia-project/engine";
import { Component, Prop, Vue } from "vue-property-decorator";
import Building from "./Building.vue";
import PlanetType from "./Conditions/PlanetType.vue";
import Sector from "./Conditions/Sector.vue";
import Federation from "./FederationTile.vue";
import Planet from "./Planet.vue";

@Component({
  components: {
    Building,
    Federation,
    Planet,
    PlanetType,
    Sector,
  },
})
export default class Condition extends Vue {
  @Prop()
  condition!: ConditionEnum;

  get isBuilding() {
    return Object.values(BuildingEnum).includes(this.condition as any);
  }

  get flat() {
    return this.$store.state.preferences.flatBuildings;
  }
}
